import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { GlobalFunctionService } from '@app/system/services/global-function.service';

export interface PlaylistCard {
	title: string;
	description?: string;
	thumbnail?: string;
	status?: string;
	rating?: number;
	commentsCount?: number;
	playlistItemCount?: number;
	creator?: string;
	date?: string;
	type?: string;
	removable?: boolean;
	userThumbnail?: string;
	statusCode?: string | Array<string>;
	forwarderName?: string;
	forwarderThumbnail?: string;
}

@Component({
	selector: 'app-playlist-card',
	templateUrl: './playlist-card.component.html',
	styleUrls: ['./playlist-card.component.scss']
})
export class PlaylistCardComponent implements OnInit {

	@Input() type: 'horizontal' | 'vertical' | 'minimal' = 'horizontal';
	@Input() data: PlaylistCard;
	@Output() detail: any = new EventEmitter();
	@Output() remove: any = new EventEmitter();
	@Output() profile: any = new EventEmitter();
	@Output() forwarderUser: any = new EventEmitter();

	playlistData;

	constructor(
		public gfService: GlobalFunctionService
	) {
	}

	ngOnInit(): void {
		this.playlistData = this.data;
		if (!([null, undefined].includes(this.data.rating))) {
			if (this.data.rating > 5) {
				this.data.rating = 5;
			}
			const range = this.range(0, Number(parseFloat(this.data.rating.toString())));
			range.splice(0, 1);
			for (let i = range.length; i < 5; i++) {
				range.push(0);
			}
			this.playlistData.ratingData = range;
		}
	}

	private range(start: number, end: number) {
		const foo: number[] = [];
		let endValue: any = end.toString().split('.');
		if (endValue.length) {
			endValue = Number(endValue[0]);
		}
		for (let i = start; i <= end; i++) {
			if (i === endValue) {
				foo.push(end);
			} else {
				foo.push(i);
			}
		}
		return foo;
	}

	isInt(n) {
		return Number(n) === n && n % 1 === 0;
	}

	isFloat(n) {
		return Number(n) === n && n % 1 !== 0;
	}

	close(data) {
		if (navigator.onLine) {
			this.remove.emit(data);
		}
	}

	info(data) {
		if (navigator.onLine) {
			this.detail.emit(data);
		}
	}

	profileInfo(data) {
		if (navigator.onLine) {
			this.profile.emit(data);
		}
	}

	forwarderUserInfo(data) {
		if (navigator.onLine) {
			this.forwarderUser.emit(data);
		}
	}

}
